/** Canonical DataLayer `type` for hotel Explore /offers/{code} products (not transport). */
export const GUEST_PLATFORM_OFFER_TYPE = "guest_platform_offer";
